
import Headline from '../ui/Headline'
import Text from '../ui/Text'

type AdvantageCardProps = {
  icon: string
  title: string
  description: string
}

function AdvantageCard({ icon, title, description }: AdvantageCardProps) {
  return (
    <div className="flex flex-col">
      <div className="h-24 md:h-44 w-full">
        <img src={icon} alt="" className="h-full w-full block mx-auto md:mx-0" />
      </div>
      <Headline size="xlarge" headline={title} className="md:mt-3" />
      <Text text={description} className="md:mt-3" />
    </div>
  )
}

export default AdvantageCard
